// We need to declare these types because this module is shared by the client & service worker.
declare interface Client {
  id: string;
  postMessage: (message: Message) => void;
}
declare interface ServiceWorker {
  postMessage: (message: Message) => void;
}

export function sendToBrowser(browser: Client, message: BrowserMessage): void {
  browser.postMessage(message);
}

export function sendToServiceWorker(sw: ServiceWorker, message: ServiceWorkerMessage): void {
  sw.postMessage(message);
}

export enum MessageType {
  // Sent by the client to request its own clientId.
  CLIENT_ID_REQUEST = 'client_id_request',
  // Response sent by the service worker containing the clientId for the requesting browser tab.
  CLIENT_ID_RESPONSE = 'client_id_response',
  // Sent by the client to start a 'Fast Refresh' for the current tab.
  INITIATE_FAST_REFRESH = 'initiate_fast_refresh',
  // Sent by the service worker once it is ready for the client to refresh.
  READY_FOR_FAST_REFRESH = 'ready_for_fast_refresh',
}

interface ReadyForFastRefreshMessage {
  messageType: MessageType.READY_FOR_FAST_REFRESH;
}
interface ClientIdResponse {
  messageType: MessageType.CLIENT_ID_RESPONSE;
  clientId: string;
}
// Message that is sent by the service worker to one or more browser tabs.
export type BrowserMessage = ReadyForFastRefreshMessage | ClientIdResponse;

interface InitiateFastRefreshMessage {
  messageType: MessageType.INITIATE_FAST_REFRESH;
}
export interface ClientIdRequest {
  messageType: MessageType.CLIENT_ID_REQUEST;
}
// Message that is sent by the client to the service worker.
export type ServiceWorkerMessage = InitiateFastRefreshMessage | ClientIdRequest;

type Message = BrowserMessage | ServiceWorkerMessage;

export default Message;
